"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _Icon = require("../Icon");
var _Spinner = require("../Spinner");
var _Button = require("../Button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LoaderIcon = () => /*#__PURE__*/_react.default.createElement(_Spinner.Spinner, {
  spinnerposition: "container",
  color: "primary",
  diameter: "1.5rem",
  thickness: ".2em solid currentColor",
  loadingtext: ""
});
const CompletedIcon = () => /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
  icon: ["fas", "check"],
  size: "2x"
});
const FailedIcon = () => /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
  icon: ["fas", "exclamation-triangle"],
  size: "2x"
});
const Preview = props => {
  const {
    files,
    params,
    showStatusIcon = false
  } = props;
  const [updatedFiles, setFiles] = (0, _react.useState)([...files]);
  const [uploadComplete, setUploadComplete] = (0, _react.useState)(false); // this state is used for refresh the meta info table

  const imgOnload = async (img, file) => {
    if (file.status === "uploading") {
      setUploadComplete(uploadComplete => !uploadComplete);
      /** inject heigth, width & status into file object */
      Object.assign(file, {
        width: img.target.naturalWidth,
        height: img.target.naturalHeight,
        status: "uploading"
      });

      /** Prepare File name (This is being used as unique name into Portal > ads form) */
      const prepFileName = [file.name?.slice(0, file.name?.lastIndexOf(".")), `_${(0, _lodash.now)()}`].join("");

      /** append file ext (png/jpg) to file name */
      const prepFileNameWithExt = [prepFileName, (0, _lodash.toLower)(file.name?.slice(file.name?.lastIndexOf(".")))].join("");

      /** convert blob URL to blob object */
      const blob = await fetch(file.preview).then(resp => resp.blob());

      /** Construct form data to be set to S3 API POST request  */
      const formdata = new FormData();
      formdata.append("key", `${params.fields.key}${prepFileNameWithExt}`);
      formdata.append("AWSAccessKeyId", params.fields.AWSAccessKeyId);
      formdata.append("x-amz-security-token", params.fields["x-amz-security-token"]);
      formdata.append("policy", params.fields.policy);
      formdata.append("signature", params.fields.signature);
      formdata.append("file", blob, "file");
      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
      };

      /** Upload file to S3 */
      await fetch(params.url, requestOptions).then(response => {
        if (response.status === 400) {
          throw statusText;
        }
        if (response.headers) {
          const getFileUrl = response.headers.get("location");
          Object.assign(file, {
            status: "completed",
            s3FileUrl: getFileUrl,
            s3FileName: prepFileName
          });
          setUploadComplete(uploadComplete => !uploadComplete);
        }
      }).catch(() => {
        Object.assign(file, {
          status: "failed"
        });
        setUploadComplete(uploadComplete => !uploadComplete);
      });
    }
  };
  const imgOnError = (img, file) => {
    Object.assign(file, {
      status: "failed"
    });
    setUploadComplete(uploadComplete => !uploadComplete);
  };
  const renderUploadStatus = status => {
    switch (status) {
      case "uploading":
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(LoaderIcon, null), " Uploading...");
        break;
      case "completed":
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!showStatusIcon && /*#__PURE__*/_react.default.createElement(CompletedIcon, null), " Completed");
        break;
      case "failed":
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!showStatusIcon && /*#__PURE__*/_react.default.createElement(FailedIcon, null), " Failed");
        break;
    }
  };
  (0, _react.useEffect)(() => {
    setFiles(files);
  }, [files]);
  (0, _react.useEffect)(() => {
    const completedFiles = (0, _lodash.filter)(files, file => {
      return file.status === "completed";
    });

    /** set successfully uploaded files to form data */
    if (props?.setValue) props?.setValue(props?.name, completedFiles);
  }, [uploadComplete]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "files--metainfo"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "files--metainfo__row"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "File Name"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Preview"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Format"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Width"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Height"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Upload Status"), /*#__PURE__*/_react.default.createElement("span", {
    className: "files--metainfo__title"
  }, "Action")), updatedFiles.map((file, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "files--metainfo__row",
      key: file.name
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, file.name), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: file.preview,
      onLoad: img => imgOnload(img, file),
      onError: img => imgOnError(img, file)
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, file.type), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, file.width, "px"), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, file.height, "px"), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `upload__status--wrapper ${file.status}`
    }, renderUploadStatus(file.status))), /*#__PURE__*/_react.default.createElement("span", {
      className: "files--metainfo__title title__value action__button"
    }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
      buttontext: "Remove",
      color: "danger",
      onClick: () => props.removeItem(file.name),
      disabled: file.status === "uploading"
    })));
  }));
};
var _default = exports.default = Preview;